import api from "./api";

export const notificationsService = {
  getNotifications: async (params = {}) => {
    // Polled every 30s by the bell dropdown and the notifications page; a 401
    // on a background tick must not yank the user to the login screen.
    const response = await api.get("/api/v1/notifications/", {
      params,
      skipAuthRedirect: true,
    });
    return response.data;
  },

  getUnreadCount: async () => {
    // Background poll: a 401 here must not redirect the user.
    const response = await api.get("/api/v1/notifications/unread-count", {
      skipAuthRedirect: true,
    });
    return response.data;
  },

  markAsRead: async (notificationId) => {
    const response = await api.patch(`/api/v1/notifications/${notificationId}/read`);
    return response.data;
  },

  markAllRead: async () => {
    const response = await api.patch("/api/v1/notifications/read-all");
    return response.data;
  },

  getPendingApprovalsCount: async () => {
    // Background poll: a 401 here must not redirect the user.
    const response = await api.get("/api/v1/notifications/pending-approvals-count", {
      skipAuthRedirect: true,
    });
    return response.data;
  },
};

export default notificationsService;
